import * as React from "react"
import { Col, Row } from "react-grid-system"
import Subtitle from "../../atoms/typography/Subtitle"
import { HorizontalSpacer } from "../../atoms/spacers"
import Body from "../../atoms/typography/Body"
import ColorfulButton from "../../atoms/buttons/ColorfulButton"
import { Link } from "react-router-dom"

const NoSearchResultPage: React.FC = () => {
  return (
    <div>
      <HorizontalSpacer spacing={3} />
      <Row>
        <Col lg={3} />
        <Col lg={6}>
          <Subtitle textAlign="center">We couldn't find what you're looking for...</Subtitle>
          <HorizontalSpacer spacing={2} />
          <Body>
            Your search yielded no results in our database. Please double check for spelling errors or try a different
            search path.
          </Body>
          <HorizontalSpacer spacing={2} />
          <Body>Need help finding something? Dont hesitate to contact us!</Body>
          <HorizontalSpacer spacing={6} />
          <Row justify="end" nogutter>
            <Link to="/contact">
              <ColorfulButton variant="blue" title="Contact us" />
            </Link>
          </Row>
        </Col>
        <Col lg={3} />
      </Row>
    </div>
  )
}

export default NoSearchResultPage
